import { ResourceType } from '../graphql-types';
import { BackendDate } from '../helper/backend-frontend-conversion.helper';
import { CustomFields } from '../../custom-form-fields/custom-form-fields.helper';
import {
    GatewayResponse,
    GetTimeFromTimestamp,
    Material,
    MaterialToSupplier,
    MaterialWoDescription,
} from '@dave/types';
import { ResourceResponse } from '@dave/types/dist/proto/erp/resource';
import { MaterialToSupplierEntity, MaterialToSupplierEntityFromBackend } from './materialToSupplier.entity';
import { AccountsReceivableLedgerEntity } from './accounts-receivable-ledger.entity';



export class MaterialEntity {
    constructor(
        public Id: number = null,
        public ProductGroupId: number = null,
        public Amount: number = null,
        public CustomFields: CustomFields[] = null,
        public PublicFileId: number = null,
        public Kostenstelle: string = null,
        public ArticleNumber: string = null,
        public Name: string = null,
        public Cost: number = null,
        public ListPrice : number = null,
        public SellPrice : number = null,
        public QuantityTypeId: number = null,
        public SellQuantityTypeId: number = null,
        public PartnerId: number = null,
        public UserId: number = null,
        public InventoryNumber: string = null,
        public GlobalTradeItemNr: string = null,
        public StorageLocation: string = null,
        public Manufacturer: string = null,
        public Description: string = null,
        public UseSurchargeRate: boolean = null,
        public CreatedAt: Date = null,
        public UpdatedAt: Date = null,
        public DeletedAt: Date = null,
        /**
         * null wenn nicht abgerufen
         */
        public SupplierIds: number[] | null = null,
        /**
         * null wenn nicht abgerufen
         */
        public UsedForInformationSupplierIds: number[] | null = null,
        /**
         *
         */
        public MaterialToSuppliers: Omit<MaterialToSupplier, 'Description'>[] | null = null,
    ) {}
    public static EntityName = 'Material';


    public Clone(override: Partial<MaterialEntity> = {}): MaterialEntity {
        const attr = { ...this, ...override };
        return Object.assign(new MaterialEntity(), attr);
    }
    public get DisplayName() {
        return [this.ArticleNumber, this.Name].filter(x => x).join(' ');
    }
    get ARLValues(): Pick<AccountsReceivableLedgerEntity, 'BookingText' | 'Information' | 'QuantityTypeId'> {
        return {
            BookingText: this.ArticleNumber,
            Information: this.Name,
            QuantityTypeId: this.QuantityTypeId,
        }
    }
}

export function MaterialEntityFromBackend(res: Material | MaterialWoDescription): MaterialEntity {
//     const amountTypeEnumValue = res.Amount ? AmountTypeEnum[res.AmountType as keyof typeof AmountTypeEnum] : null;

    return new MaterialEntity(
        res.Id && +res.Id,
        res.ProductGroupId && +res.ProductGroupId,
        res.Amount && +res.Amount,
        res.CustomFields && JSON.parse(res.CustomFields),
        res.PublicFileId && +res.PublicFileId,
        res.Kostenstelle,
        res.ArticleNumber,
        res.Name,
        res.Cost && +res.Cost,
        res.ListPrice && +res.ListPrice,
        res.SellPrice && +res.SellPrice,
        res.QuantityTypeId && +res.QuantityTypeId,
        res.SellQuantityTypeId && +res.SellQuantityTypeId,
        res.PartnerId && +res.PartnerId,
        res.UserId && +res.UserId,
        res.InventoryNumber,
        res.GlobalTradeItemNr,
        res.StorageLocation,
        res.Manufacturer,
        (res  as Material).Description,
        res.UseSurchargeRate,
        res.CreatedAt && GetTimeFromTimestamp(+res.CreatedAt),
        res.UpdatedAt && GetTimeFromTimestamp(+res.UpdatedAt),
        res.DeletedAt && GetTimeFromTimestamp(+res.DeletedAt),
        (res as MaterialWoDescription).SupplierIds?.SupplierIds ? (res as MaterialWoDescription).SupplierIds.SupplierIds.map(id => +id) : null,
        (res as MaterialWoDescription).UsedForInformationSupplierIds?.SupplierIds ? (res as MaterialWoDescription).UsedForInformationSupplierIds.SupplierIds.map(id => +id) : null,
        (res as MaterialWoDescription).MaterialToSuppliers?.MaterialToSuppliers ? (res as MaterialWoDescription).MaterialToSuppliers.MaterialToSuppliers as Array<Omit<MaterialToSupplier, 'Description'>> : null,
    );
}



